<template>
	<UITopHeading>Datenschutz</UITopHeading>
	<div class="container flex flex-col">
		<SharedTheSecurity />
	</div>
	<UITopHeading>Bildrechte</UITopHeading>
	<div class="container flex flex-col">
		<SharedTheImageSecurity />
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Datenschutz',
	ogTitle: 'Datenschutz',
	twitterTitle: 'Datenschutz',
	description: 'Die Datenschutzbestimmungen des Propellerfestivals.',
	ogDescription: 'Die Datenschutzbestimmungen des Propellerfestivals.',
	twitterDescription: 'Die Datenschutzbestimmungen des Propellerfestivals.',
	ogUrl: 'https://propellerfestival.de/datenschutz',
})
</script>
